module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/2-ls-9f4310966ad28db02db81b22838333b7.webp";